import { AsyncStoreItem } from '@lib/store';
import { FareConditionsResponse } from 'src/sdk-servicing';

/**
 * GetFareConditions model
 */
export interface GetFareConditionsModel {
  model: FareConditionsResponse | null;
}

/**
 * FareConditionsResponse model details
 */
export interface GetFareConditionsStateDetails extends AsyncStoreItem {}

/**
 * GetFareConditions store state
 */
export interface GetFareConditionsState extends GetFareConditionsStateDetails, GetFareConditionsModel {}

/**
 * Name of the GetFareConditions Store
 */
export const GET_FARE_CONDITIONS_STORE_NAME = 'getFareConditions';

/**
 * GetFareConditions Store Interface
 */
export interface GetFareConditionsStore {
  /** GetFareConditions state */
  [GET_FARE_CONDITIONS_STORE_NAME]: GetFareConditionsState;
}
